/**
* Book Animation JS
* -----------------------------------------------------------------------------
*
* All the JS for the Book Animation component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {CustomEase} from 'gsap/CustomEase.js';

( function( app ) {
  const COMPONENT = {

    className: 'book-animation',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( CustomEase );

      CustomEase.create( 'fastForwardChevrons', 'M0,0,C0.266,0.412,0.451,0.545,0.58,0.666,0.612,0.696,0.753,0.829,0.87,0.914,0.928,0.956,0.942,1,1,1' );

      $( '.book-animation' ).each( function() {
        gsap.to( '#chevrons-running path', {
          repeat: -1,
          repeatDelay: 3,
          x: 20,
          stagger: {
            each: 0.1,
            from: 0,
          },
          ease: 'fastForwardChevrons',
          lazy: false,
        }
        );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'book-animation', COMPONENT );
} )( app );
